// @ts-nocheck

import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useMergeProps from '../../../../hooks/useMergeProps';
import { useBoomContext } from '../../contexts/BoomContext';
import { selectBoomStepsEntity } from '../../selectors/steps/stepsPrimary.selector';
import { selectBoomUserProgressEntityWonAmount } from '../../selectors/user/userPrimary.selector';
import { selectBoomUserProgressStepIsCompleted } from '../../selectors/user.selector';

import BoomStepDetails from './BoomStepDetails';

type PropsType = {
  className?: string;
  stepId: string;
};

function BoomStepDetailsContainer(ownProps: PropsType) {
  const { stepId } = ownProps;

  const { skinId } = useBoomContext();

  const selectorProps = useMemo(() => ({ stepId }), [stepId]);
  const isCompleted = useSelector((state) => selectBoomUserProgressStepIsCompleted(state, selectorProps));
  const stepInfo = useSelector((state) => selectBoomStepsEntity(state, selectorProps));
  const wonAmount = useSelector((state) => selectBoomUserProgressEntityWonAmount(state, selectorProps));

  const selectedProps = useMemo(
    () => ({
      ...stepInfo.eligibility,
      stakeMultiplier: stepInfo.stakeMultiplier,
      wonAmount,
      isCompleted,
    }),
    [stepInfo, isCompleted, wonAmount],
  );

  const otherProps = useMemo(() => ({ skinId }), [skinId]);

  const enhancedProps = useMergeProps({ selectedProps, ownProps, otherProps });

  return <BoomStepDetails {...enhancedProps} />;
}

export default BoomStepDetailsContainer;
